












































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModalCrear.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import Confirmation from '@/components/Confirmation.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { fetchMS } from '@/pantallas/Conecta/SolicitudStock/fetchMS';
import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';
import {
  GetQuickFilterTextParams,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
  ValueFormatterParams,
  ColDef,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    NavegacionModalCrud,
    Confirmation,
    FormFieldsContainer,
    DatePicker,
    MantenedorGridSinCodigo,
  },
})
export default class ModalCrear extends Vue {
  @Prop({ default: true }) show: boolean;
  readonly funcionalidad: Funcionalidades = Funcionalidades.SolicitudStock;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  dialogConfirmacionGuardar: boolean = false;
  mensajeConfirmacion: any = '';
  listaModalidad: any[] = [];
  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
  listaClientes: any[] = [];
  listaFlotas: any[] = [];

  showInfo: boolean = true;
  fileName: any = '';
  archivoB64: any = '';
  itemsDelExcel: Array<any> = [];
  errorArchivo: boolean = true;
  errorArchivoModal: boolean = false;

  formFields: FormFieldDefMap = {
    requerimiento: {
      label: 'Requerimiento',
      id: 'requerimiento',
      value: '',
    },
    adp: {
      label: 'ADP',
      id: 'adp',
      value: '',
    },
    rutCliente: {
      label: 'Rut Cliente',
      id: 'rutCliente',
      value: '',
      items: [],
    },
    flota: {
      label: 'Flota',
      id: 'flota',
      value: '',
      items: [],
    },
    fecha: {
      label: 'Fecha ',
      id: 'fecha',
      value: moment(this.fechaMaxima),
    },
    serieactivamodalidad: {
      label: 'Modalidad',
      id: '',
      value: '',
    },
    oc: {
      label: 'Orden de Compra',
      id: '',
      value: '',
    },
    mandante: {
      label: 'Mandante',
      id: '',
      value: '',
    },
    asignota: {
      label: 'Nota',
      id: '',
      value: '',
    },
  };

  async getModalidad() {
    let resp: any = (await this.cargarModalidad()) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    } else {
      this.listaModalidad = resp.data.data;
    }
  }

  cargarModalidad() {
    this.loadingService.showLoading(undefined, 'cargarModalidad');
    let self = this;
    return fetchMS({}, 'get_modalidad')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los AVL',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los AVL',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('cargarModalidad'));
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  async handleConfirmacionGuardar(val: boolean) {
    if (!val) {
      this.dialogConfirmacionGuardar = false;
    } else {
      let resp: any = (await this.crearRequerimiento()) || [];
      if (resp.data.CODIGO_RESPUESTA != '1') {
        this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 5000 });
        this.dialogConfirmacionGuardar = false;
      } else {
        this.$snotify.success(resp.data.MENSAJE_RESPUESTA, { timeout: 8000 });
        this.handleCerrar();
      }
    }
  }

  async crearRequerimiento() {
    this.loadingService.showLoading(undefined, 'crearRequerimiento');
    let body: any = {};
    body.requerimiento = this.formFields.requerimiento.value;
    body.adp = this.formFields.adp.value;
    body.rutCliente = this.formFields.rutCliente.value;
    body.flota = this.formFields.flota.value;
    body.fecha = this.formFields.fecha.value;
    body.modalidad = this.formFields.serieactivamodalidad.value;
    body.mandate = this.formFields.mandante.value;
    body.oc = this.formFields.oc.value;
    body.id_usuario = JSON.parse(window.localStorage.user).id;
    body.modulo = this.funcionalidad;
    body.asignota = this.formFields.asignota.value;
    body.series = this.itemsDelExcel;
    body.file = this.archivoB64;
    body.fileName = this.fileName;
    let self = this;
    return fetchMS(body, 'crearRequerimiento')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('crearRequerimiento'));
  }

  async getClientes() {
    let resp: any = (await this.cargarClientes()) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    } else {
      this.listaClientes = resp.data.data;
    }
  }

  cargarClientes() {
    this.loadingService.showLoading(undefined, 'getClientes');
    let self = this;
    return fetchMS({}, 'getClientes')
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('getClientes'));
  }

  async getFlotas() {
    let resp: any = (await this.cargarFlotas()) || [];
    if (resp.data.CODIGO_RESPUESTA != '1') {
      this.$snotify.error(resp.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      this.listaFlotas = [];
    } else {
      this.listaFlotas = resp.data.data.LISTA;
    }
  }

  cargarFlotas() {
    this.loadingService.showLoading(undefined, 'getFlotas');
    let self = this;
    return fetchMS(
      { id_cliente: this.formFields.rutCliente.value },
      'getFlotas'
    )
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => self.loadingService.hideLoading('getFlotas'));
  }

  created() {
    this.getClientes();
    this.getModalidad();
  }

  handleCerrar() {
    this.$emit('cerrar');
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
  handleGuardar() {
    let isValid = true;

    if (this.itemsDelExcel.length == 0) {
      this.$snotify.error('Debe cargar una planilla con datos validos');
      return;
    }

    if (
      this.formFields.rutCliente.value == '' ||
      this.formFields.rutCliente.value === null
    ) {
      this.$snotify.error('Debe seleccionar un cliente');
      return;
    }

    this.mensajeConfirmacion =
      '¿Está seguro que desea crear este requerimiento? ';
    if (isValid) {
      this.dialogConfirmacionGuardar = true;
    }
  }

  async descargarPlantilla(tipo: any = 'PENDIENTES') {
    this.loadingService.showLoading(undefined, 'check_tipoproveedor_oc');
    let headers = {};
    headers = {
      header: [
        'EQUIPO',
        'SERIE',
        'PLATAFORMA',
        'TÉCNICO',
        'REGIÓN',
        'CIUDAD',
        'ESTATUS',
        'STOCK',
        'CAS-NDV ASIGNADO',
      ],
    };
    let ws: any = null;
    let name: string = '';

    ws = utils.json_to_sheet([], headers);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    //writeFileXLSX(wb, 'SeriesOC.xlsx');
    writeFileXLSX(wb, `Plantilla_Ejemplo_Solicitud_Stock.xlsx`);
    this.$snotify.success('Plantilla Excel descargada con éxito');
    this.loadingService.hideLoading('check_tipoproveedor_oc');
  }

  errorMessage: any = '';
  prepare_file_upload() {
    this.loadingService.showLoading('carga_archivo_stock');
    const input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input != null && input.files) {
      this.fileName = input.files[0].name;
      const file = input.files[0];
      const reader = new FileReader();
      let rawImg;
      reader.onloadend = () => {
        rawImg = reader.result;
        this.archivoB64 = rawImg;
      };
      reader.readAsDataURL(file);
      readXlsFile(input.files[0])
        .then((rows: any) => {
          let datos: any = [...rows];
          if (datos.length == 0) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "EQUIPO"'
            );
            this.errorArchivo = true;
            this.loadingService.hideLoading('carga_archivo_stock');
            return;
          }
          let firtsRow: any = datos[0] || '';
          if (firtsRow[0].toLowerCase() != 'equipo') {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "EQUIPO"'
            );
            this.errorArchivo = true;
            this.loadingService.hideLoading('carga_archivo_stock');
            return;
          }

          //validos los nombres de las columnas
          if (
            datos[0][0].toLowerCase() != 'equipo' ||
            datos[0][1].toLowerCase() != 'serie' ||
            datos[0][2].toLowerCase() != 'plataforma' ||
            datos[0][3].toLowerCase() != 'técnico' ||
            datos[0][4].toLowerCase() != 'región' ||
            datos[0][5].toLowerCase() != 'ciudad' ||
            datos[0][6].toLowerCase() != 'estatus' ||
            datos[0][7].toLowerCase() != 'stock' ||
            datos[0][8].toLowerCase() != 'cas-ndv asignado'
          ) {
            this.$snotify.warning(
              'Las columnas no coinciden con el formato esperado. Por favor, descargue la plantilla y complete los datos nuevamente.'
            );
            this.errorArchivo = true;
            this.loadingService.hideLoading('carga_archivo_stock');
            return;
          }

          datos = datos.splice(1);
          if (!datos[0]) {
            this.$snotify.warning(
              'Se espera que la primera columna tenga el título "EQUIPO"'
            );
            this.errorArchivo = true;
            this.loadingService.hideLoading('carga_archivo_stock');
            return;
          }

          let hasError = false;

          this.itemsDelExcel = datos.map((item: any, index: number) => {
            return {
              equipo: item[0] || '',
              serie: item[1] || '',
              plataforma: item[2] || '',
              tecnico: item[3] || '',
              region: item[4] || '',
              ciudad: item[5] || '',
              estatus: item[6] || '',
              stock: item[7] || '',
              cas_ndv_asignado: item[8] || '',
              idUser: JSON.parse(window.localStorage.user).id,
            };
          });
          this.itemsDelExcel = this.itemsDelExcel.filter(item => item !== null);
          this.errorArchivo = false;
          this.errorArchivoModal = false;
          this.cargar();
          this.loadingService.hideLoading('carga_archivo_stock');
        })
        .catch((e: any) => {
          console.log(e);
          this.itemsDelExcel = [];
          this.errorMessage = `Ocurrió un error al leer el archivo: ${e.message}<br>`;
          this.errorArchivo = true;
          this.errorArchivoModal = true;
        });
    }
  }

  quitarRegistro() {
    let input = document.getElementById(
      'archivoExcel'
    ) as HTMLInputElement | null;
    if (input) {
      input.value = ''; // Restablecer el valor del input
    }
    this.itemsDelExcel = [];
    this.archivoB64 = '';
    this.fileName = '';
    this.errorArchivoModal = false;
    this.errorMessage = '';
    this.errorArchivo = true;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }

  cargar() {
    const body = this.itemsDelExcel;
    let self = this;
    this.gridApi.setRowData(body);
    this.gridApi.setDomLayout('autoHeight');
  }

  gridApi: GridApi = null;
  gridOptions: GridOptions;
  columnDefs: Array<ColDef> = [];
  columnApi: any = null;
  gridEvent: any = null;
  ordesList: any[] = [];

  constructor() {
    super();
    //this.actions();

    this.columnDefs = [
      {
        headerName: 'Equipo',
        field: 'equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Serie',
        field: 'serie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Técnico',
        field: 'tecnico',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Región',
        field: 'region',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Ciudad',
        field: 'ciudad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Estatus',
        field: 'estatus',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Stock',
        field: 'stock',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'CAS-NDV Asignado',
        field: 'cas_ndv_asignado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
    ];
    this.gridOptions = {
      pagination: true,
      paginationPageSize: 50,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.ordesList = [];
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }

    /*     this.gridApi.setServerSideDatasource(this.serverSide);
     */
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
}
